<template>
  <div>
    <input type="tel" class="form-control" v-model="formattedNumber" @input="onInput" @keydown="onKeydown"
      @paste="onPaste" placeholder="+1 (XXX) XXX-XXXX" :disabled="disabled" />
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';

export default {
  props: {
    modelValue: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'validationStatus', 'errorMessage'],
  setup(props, { emit }) {
    const formattedNumber = ref('');
    const errorMessage = ref('');

    // Function to format the number in (xxx) xxx-xxxx format with +1
    // function formatPhoneNumber(value) {
    //   const cleaned = value.replace(/\D/g, '');
    //   if (cleaned.length <= 3) {
    //     return `+1 (${cleaned}`;
    //   } else if (cleaned.length <= 6) {
    //     return `+1 (${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    //   } else {
    //     return `+1 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    //   }
    // }
    function formatPhoneNumber(value) {
      const cleaned = value.replace(/\D/g, '');

      let numberToFormat = cleaned;

      // If number starts with 1 and is 11 digits → skip the 1 for display
      if (cleaned.length === 11 && cleaned.startsWith('1')) {
        numberToFormat = cleaned.slice(1);
      }

      if (numberToFormat.length <= 3) {
        return `+1 (${numberToFormat}`;
      } else if (numberToFormat.length <= 6) {
        return `+1 (${numberToFormat.slice(0, 3)}) ${numberToFormat.slice(3)}`;
      } else {
        return `+1 (${numberToFormat.slice(0, 3)}) ${numberToFormat.slice(3, 6)}-${numberToFormat.slice(6, 10)}`;
      }
    }

    function onPaste(event) {
      const paste = (event.clipboardData || window.clipboardData).getData('text');

      // Remove all non-digit characters and limit to 10 digits
      const digitsOnly = paste.replace(/\D/g, '');

      // Format the number
      formattedNumber.value = formatPhoneNumber(digitsOnly);

      // Emit the formatted number with +1 prefix
      // const finalNumber = digitsOnly ? `1${digitsOnly}` : '';
      emit('update:modelValue', digitsOnly);
    }


    // function onInput(event) {
    //   const input = event.target.value;
    //   let digitsOnly = input.replace(/\D/g, '');

    //   if (input.startsWith('+1')) {
    //     digitsOnly = digitsOnly.slice(1); // Remove user-entered +1
    //   }

    //   if (digitsOnly.length > 10) {
    //     digitsOnly = digitsOnly.slice(0, 10);
    //   }

    //   formattedNumber.value = formatPhoneNumber(digitsOnly);
    //   emit('update:modelValue', digitsOnly ? `1${digitsOnly}` : '');

    //   const isValid = digitsOnly.length === 10;

    //   // Emit validation status
    //   emit('validationStatus', isValid);

    //   // Emit error message if invalid, otherwise clear the error
    //   if (!isValid && digitsOnly.length > 0) {
    //     errorMessage.value = 'Phone number must be 10 digits.';
    //     emit('errorMessage', errorMessage.value);
    //   } else {
    //     errorMessage.value = '';
    //     emit('errorMessage', ''); // Clear the error
    //   }

    //   // If the input is empty, clear both validation status and error
    //   if (digitsOnly.length === 0) {
    //     emit('validationStatus', false);
    //     emit('errorMessage', '');
    //   }
    // }
    function onInput(event) {
      const input = event.target.value;
      let digitsOnly = input.replace(/\D/g, '');

      if (digitsOnly.length > 11) {
        digitsOnly = digitsOnly.slice(0, 11);
      }

      formattedNumber.value = formatPhoneNumber(digitsOnly);
      emit('update:modelValue', digitsOnly);

      // Validate: check if last 10 digits are entered (after country code)
      let isValid = false;
      if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
        isValid = true;
      } else if (digitsOnly.length === 10) {
        isValid = true;
      }

      emit('validationStatus', isValid);

      if (!isValid && digitsOnly.length > 0) {
        errorMessage.value = 'Phone number must be 10 digits.';
        emit('errorMessage', errorMessage.value);
      } else {
        errorMessage.value = '';
        emit('errorMessage', '');
      }

      if (digitsOnly.length === 0) {
        formattedNumber.value = '';
        emit('update:modelValue', '');
        emit('validationStatus', false);
        emit('errorMessage', '');
        return; // Stop further processing
      }

    }

    // Handle keydown to allow full backspacing, including +1
    function onKeydown(event) {
      if (event.key === 'Backspace') {
        if (formattedNumber.value === '+1 (' || formattedNumber.value === '+1' || formattedNumber.value.length <= 4) {
          // Clear everything
          formattedNumber.value = '';
          emit('update:modelValue', '');
          emit('validationStatus', false);
          emit('errorMessage', '');
        }
      }
    }


    // // Watch the prop to set the initial value of the input
    watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue) {
      const digitsOnly = newValue.replace(/\D/g, '');
      formattedNumber.value = formatPhoneNumber(digitsOnly.replace(/^1/, ''));
    } else {
      formattedNumber.value = '';
      emit('errorMessage', '');
    }
  },
  { immediate: true } // ← this is the key
);

    // Initialize formattedNumber on component load && newly added code
    onMounted(() => {
      // if (props.modelValue) {
      //   formattedNumber.value = formatPhoneNumber(props.modelValue.replace('1', ''));
      // }
    })

    return {
      formattedNumber,
      onInput,
      onKeydown,
      onPaste,
    };
  }
};
</script>
